export const LOTTO90_REQUEST_FETCH_DRAWING_RESULT = "LOTTO90_REQUEST_FETCH_DRAWING_RESULT"

export const LOTTO90_REQUEST_FETCH_WIN_LOSS_REPORT = "LOTTO90_REQUEST_FETCH_WIN_LOSS_REPORT"

export const LOTTO90_REQUEST_FETCH_RESULT_REPORT = "LOTTO90_REQUEST_FETCH_RESULT_REPORT"
export const LOTTO90_SET_DRAWING = "LOTTO90_SET_DRAWING"


export const LOTTO90_RECENT_TICKET = "LOTTO90_RECENT_TICKET";
